import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { transferLeadToBike } from '../../requests/final_confirmation_request';
import { TRANSFER_LEAD_TO_BIKE } from '../constants/final_confirmation.constants';
import { transferLeadToBikeSuccess, transferLeadToBikeFailure } from '../actions/final_confirmation.actions';

function* transferLeadToBikeRequest({ params }) {
    const { result, options, error } = yield call(transferLeadToBike, params);

    if (result) {
        yield put(transferLeadToBikeSuccess(options));
        message.success('TCard successfully added!');
    } else {
        yield put(transferLeadToBikeFailure(error));
        message.error(error && (error.message || error.msg));
    }
}

export default function* transferLeadToBikeSaga() {
    yield takeEvery(TRANSFER_LEAD_TO_BIKE, transferLeadToBikeRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/transer_lead_to_bike.saga.js